import styled from 'styled-components'

export default styled.div`
  /* padding-bottom: 79px; */
  /* width: 100vw; */
  margin: 44px auto 70px;
  padding: 0 4.26vw;

  display: flex;
  flex-wrap: wrap;

  &:last-child {
    margin-bottom: 0;
  }

  /* &.row {
    margin: auto;
  } */

  .product-imgbox {
    /* padding-left: 16px; */
    /* padding-right: 0; */
    width: 39.47vw;
    min-width: 39.47vw;
    min-height: 39.47vw;
    max-width: 148px;
    max-height: 148px;
    overflow: hidden;
  }

  .product-image-default, .product-image {
    display: block;
    max-width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/styles/ProductBox.js